<div
	[class.h-[60vh]]="!(controller.isHandsetLandscape$ | async)"
	[class.h-screen]="controller.isHandsetLandscape$ | async"
	class="flex w-full"
>
	<p-card
		[styleClass]="(controller.isHandsetLandscape$ | async) ? '' : 'h-full'"
		class="w-full"
	>
		<div
			[class.h-full]="!(controller.isHandsetLandscape$ | async)"
			[class.h-screen]="controller.isHandsetLandscape$ | async"
			class="flex flex-col"
		>
			<spr-coachee-profile-meetings-header></spr-coachee-profile-meetings-header>
			<spr-coachee-profile-meetings-filter></spr-coachee-profile-meetings-filter>
			<div class="flex-1 relative">
				<ng-scrollbar
					(reached)="onReached()"
					class="absolute inset-0"
					infiniteScroll
					visibility="hover"
				>
					<spr-coachee-profile-meetings-meeting
						*ngFor="let task of controller.meetings$ | async"
						[task]="task"
					></spr-coachee-profile-meetings-meeting>
				</ng-scrollbar>
			</div>
		</div>
	</p-card>
</div>
